/*
 * @Author: Latte
 * @Date: 2021-09-08 14:33:15
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-17 11:33:37
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\mai\couponsManagement\couponsManagement.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * 后台卡券管理
 */
/**
 * @description: 查询所有卡券记录
 * @param {*} params
 * @return {*}
 */
export function getCouponList(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/AllCouponList",
		method: "get",
		headers: { 'permissionList': 'admin' },
		params,
	});
}

/**
 * @description: 后台管理删除或者恢复卡券申请记录
 * @param {*} params
 * @return {*}
 */
export function switchCouponReqRecord(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/CouponRequest/DeleteOrBack",
		method: "delete",
		params,
	});
}

/**
 * @description: 查询所有卡券申请记录
 * @param {*} params
 * @return {*}
 */
export function getCouponReqList(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/CouponRequestList",
		method: "get",
		params,
	});
}

/**
 * @description: 删除卡券
 * @param {*} params
 * @return {*}
 */
export function deleteCoupon(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/Coupons/Delete",
		method: "delete",
		params,
	});
}

/**
 * @description: 后台管理删除或者恢复卡券赠送记录
 * @param {*} params
 * @return {*}
 */
export function switchCardGiftRecord(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/CouponSendRecord/DeleteOrBack",
		method: "delete",
		params,
	});
}


/**
 * @description: 后台管理分页查询卡券赠送记录
 * @param {*} params
 * @return {*}
 */
export function getCardGiftRecord(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/CouponSendRecordList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台管理分配直播券
 * @param {*} data
 * @return {*}
 */
export function addLiveCoupon(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/LiveCoupon/Add",
		method: "post",
		data,
	});
}

/**
 * @description: 后台管理分配视频券
 * @param {*} data
 * @return {*}
 */
export function addVideoCoupon(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminCoupons/VideoCoupon/Add",
		method: "post",
		data,
	});
}

